import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * SEO-friendly Breadcrumb component
 * Implements structured data for Google rich snippets
 */
export default function Breadcrumb({ items }) {
  // items = [{ label: "Veille marchés publics", href: "/veille-marches-publics" }, ...]
  
  // Filter items with href for JSON-LD (last item typically has no href)
  const itemsWithHref = items.filter(item => item.href);
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://dce-express.fr"
      },
      ...itemsWithHref.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": item.label,
        "item": `https://dce-express.fr${item.href}`
      })),
      // Add current page as last item (without "item" URL as per Google guidelines for current page)
      {
        "@type": "ListItem",
        "position": itemsWithHref.length + 2,
        "name": items[items.length - 1].label
      }
    ]
  };

  return (
    <>
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Visual Breadcrumb */}
      <nav aria-label="Fil d'Ariane" className="flex items-center gap-2 text-sm text-slate-500 mb-6">
        <Link 
          to="/" 
          className="flex items-center gap-1 hover:text-violet-600 transition-colors"
        >
          <Home className="w-4 h-4" />
          <span>Accueil</span>
        </Link>
        
        {items.map((item, index) => (
          <React.Fragment key={`item-${index}`}>
            <ChevronRight className="w-4 h-4 text-slate-300" />
            {index === items.length - 1 ? (
              <span className="text-slate-900 font-medium">{item.label}</span>
            ) : (
              <Link 
                to={item.href} 
                className="hover:text-violet-600 transition-colors"
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
}
